import { DocumentListV2, DocumentV2 } from "@hagerty/customer-insurance-gateway-client";

import { getFormattedDate } from "../../utils/getFormattedDate";

export const createCigDocumentsList = (documents: DocumentV2[]): DocumentListV2 => ({
  page: 0,
  pageSize: documents.length,
  hasMore: false,
  documents,
});

export const cigIdCardDocument = (baseUrl: string, policyNumber: string): DocumentV2 => ({
  id: "123",
  name: `${policyNumber} ID Card`,
  isActive: true,
  createdDate: getFormattedDate({ days: -7 }),
  isSensitive: false,
  originalFileName: "",
  contentAccess: {
    url: `${baseUrl}/test-id-card-url/${policyNumber}`,
    expiresAt: "",
    generatedUrlTtl: 0,
    mediaType: "",
  },
  tags: ["ID-CARD"],
  associatedIds: [],
});
